export { default } from '../../sub/domains';

